export function isOnboardingFrontendEnabled() {
  return process.env.REACT_APP_ENABLE_ONBOARDING_FRONTEND === "true";
}

